import React from "react";
import { fetchOne } from "../utils/fetchResources";
import { Link } from "react-router-dom";
import { SiteContext } from "../contexts/SiteContext";
import {
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Typography,
  Divider,
} from "@material-ui/core";

function EntryResult({ result, index }) {
  const { selectedSite } = React.useContext(SiteContext);
  const [file, setFile] = React.useState();
  const [loading, setLoading] = React.useState(true);

  // Support both ES-shaped hits (_source) and plain Mongo docs
  const doc = result && result._source ? result._source : result;

  React.useEffect(() => {
    if (doc && doc.featuredImage) {
      // featuredImage is assumed to be a File _id
      fetchOne("files", doc.featuredImage, setFile);
    }
    setLoading(false);
  }, [result]); // re-run if result changes

  if (loading || !doc || !selectedSite) {
    return <div>Loading...</div>;
  }

  return (
    <>
      <ListItem
        component={Link}
        to={`/${selectedSite.slug}/entries/${doc.slug || doc._id}`}
        key={index}
      >
        <ListItemAvatar>
          <Avatar
            alt="Entry Thumbnail"
            src={
              file && `${process.env.REACT_APP_FILE_URL}/${file.thumbnailName}`
            }
            style={{ height: "75px", width: "75px", marginRight: "1rem" }}
            variant="rounded"
          >
            E
          </Avatar>
        </ListItemAvatar>
        <ListItemText
          primary={
            <>
              <Typography
                style={{ display: "inline" }}
                component="span"
                variant="h6"
                color="primary"
              >
                Entry
              </Typography>
            </>
          }
          secondary={
            <>
              <Typography
                style={{ display: "inline" }}
                component="span"
                color="text.primary"
              >
                {doc.title}
              </Typography>
            </>
          }
        />
      </ListItem>
      <Divider component="li" />
    </>
  );
}

export default EntryResult;

